export const Url =
  process.env.NODE_ENV !== 'production'
    ? 'http://localhost:5000'
    : 'https://shop-app-axbf.onrender.com'
